import { PortableText } from '@portabletext/react'
import { data } from 'react-router'
import { type Faq } from '#app/types/sanity.types.ts'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/index.ts'

export async function loader({ request: _request }: Route.LoaderArgs) {
	const query = `*[_type == "faq"] | order(order asc, _createdAt asc)`
	const questions = await safeFetch<Faq[]>(query)

	if (!questions || questions.length === 0) {
		throw data('No FAQs found', { status: 404 })
	}

	return { questions }
}

export default function Index({ loaderData }: Route.ComponentProps) {
	const { questions } = loaderData
	return (
		<main className="font-poppins w-[calc(100%-12px)] place-items-center px-4">
			<h1 className="text-4xl">Frequently Asked Questions</h1>
			<div className="max-auto mx-auto max-w-5xl py-12">
				<dl className="space-y-10">
					{questions.map((item) => (
						<div key={item._id} className="flex flex-col gap-2">
							<dt className="text-xl font-bold text-slate-900 dark:text-slate-400">
								{item.question}
							</dt>
							<dd className="text-md leading-5 text-slate-700 dark:text-slate-50">
								<PortableText
									value={Array.isArray(item.answer) ? item.answer : []}
									components={{
										marks: {
											link: ({ children, value }) => (
												<a
													href={value.href}
													target="_blank"
													rel="noopener noreferrer"
													className="text-blue-700 no-underline transition-colors hover:text-blue-900"
												>
													{children}
												</a>
											),
										},
										list: {
											bullet: ({ children }) => (
												<ul className="list-disc space-y-1 pl-5">{children}</ul>
											),
											number: ({ children }) => (
												<ol className="list-decimal space-y-1 pl-5">
													{children}
												</ol>
											),
										},
									}}
								/>
							</dd>
						</div>
					))}
				</dl>
			</div>
		</main>
	)
}
